module.exports = __webpack_public_path__ + "static/media/aw-icon-sunset.8742061a.svg";